const RESOURCE_NAME = '/notifications-events';

export default axios => ({
    getAll(unitId, params) {
        let url = `${RESOURCE_NAME}`
        if (unitId > '') url = `/unit/${unitId}`+url
        return axios.get(url, {params});
    },
    getLast(unitId, last, params) {
        let url = `${RESOURCE_NAME}/last`
        if (unitId > '') url = `/unit/${unitId}`+url
        //?last/(n (sec|second|min|minute|hour|day|month)(s?))
        if (last > '') url+= `/${last}`
        return axios.get(url, {params});
    },
    get4Date(unitId, date, params) {
        let url = `${RESOURCE_NAME}/${date}`
        if (unitId > '') url = `/unit/${unitId}`+url
        return axios.get(url, {params});
    },
    get4Period(unitId, from, to, params) {
        let url = `${RESOURCE_NAME}/${from}/${to}`
        if (unitId > '') url = `/unit/${unitId}`+url
        return axios.get(url, {params});
    },
    getStatistics(unitId, params) {
        let url = `${RESOURCE_NAME}/statistics`
        if (unitId > '') url = `/unit/${unitId}`+url
        return axios.get(url, {params});
    },
});